module.exports = __webpack_public_path__ + "img/164.2ef7cc05.jpg";